<template>
  <Modal
    v-model="_value"
    width="700"
    title="业务笔记"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <div style="position:relative;">
      <Table border highlight-row size="small" height="200" :columns="columns" :stripe="true" :data="content" ref="table"
             @on-sort-change="sortChange"></Table>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <Form autoComplete="on" class="card-box login-form">

    </Form>
    <Row type="flex" justify="end">
      <Button type="primary" style="margin-right: 5px;" @click="onBusinessNoteDetailModal">添加笔记</Button>
    </Row>
    <business-note-detail-modal v-model="businessNoteDetailModal" :initValue="businessNoteInfo"
                                :showBusinessState="false"
                                @on-success="onModifySuccess"></business-note-detail-modal>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'

export default {
  name: 'businessnotelistmodal',
  components: {
    BusinessNoteDetailModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        vehicleInfoId: null
      },

      modify: false,
      positioningDeviceInfoDetailId: null,
      positioningDeviceInfo: {
        id: null,
        terminalNum: null,
        factoryTerminalNum: null,
        positioningDeviceModel: null,
        positioningDeviceModelId: null,
        sourceType: null,
        remark: null,
        setupDatetime: null,
        serviceDatetime: null
      },
      listLoadding: false,
      columns: [
        {
          title: 'ID',
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          minWidth: 70
        },
        {
          title: '业务员',
          key: 'user',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            let user = null
            if (params.row.user.realName) {
              user = params.row.user.realName
            } else {
              user = params.row.user.nickName
            }
            return h('div', user)
          }
        },
        {
          title: '笔记类型',
          key: 'pubType',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            let pubType = params.row.pubType
            if (pubType === 1) {
              return h('div', '不公开')
            } else if (pubType === 2) {
              return h('div', '公开名字')
            } else if (pubType === 3) {
              return h('div', '公开内容')
            } else {
              return h('div', '未知')
            }
          }
        },
        {
          title: '颜色标签',
          key: 'colorLabel',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            let colorLabel = params.row.colorLabel
            if (colorLabel == 'ed4014') {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    color: 'red'
                  }
                }, '红色')
              ])
            } else if (colorLabel == 'ff9900') {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    color: 'orange'
                  }
                }, '橙色')
              ])
            } else if (colorLabel == 'ffff00') {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    color: 'yellow'
                  }
                }, '黄色')
              ])
            } else if (colorLabel == '19be6b') {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    color: 'green'
                  }
                }, '绿色')
              ])
            } else if (colorLabel == '2db7f5') {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    color: 'blue'
                  }
                }, '蓝色')
              ])
            } else if (colorLabel == '8a2be2') {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    color: 'purple'
                  }
                }, '紫色')
              ])
            }
          }
        },
        {
          title: '最近修改时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'updateDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 110,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.businessNoteInfo.vehicleInfoId = this._initValue
                    this.businessNoteInfo.id = params.row.id
                    this.businessNoteDetailModal = true
                    this.$emit('on-success')
                  }
                }
              }, '详细信息')
            ])
          }
        }
      ]
    }
  },
  methods: {
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    onModifySuccess () {
      this.updateTable()
      this.$emit('on-success')
    },
    updateTable () {
      this.listLoadding = true
      let queryParams = []
      let sortParam = null
      queryParams.push(genQueryParam('vehicleInfoId', 'EQ', this._initValue))
      store.dispatch('BusinessNoteServ_GetMyAllCanSee', {
        params: {
          vehicleId: this._initValue
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    onBusinessNoteDetailModal(){
      this.businessNoteInfo.vehicleInfoId = this._initValue
      this.businessNoteInfo.id = null
      this.businessNoteDetailModal = true
      this.$emit('on-success')
    },
    visibleChange (val) {
      if (val) {
        this.businessNoteInfo.vehicleInfoId = this._initValue
        let vehicleInfoId = this._initValue
        if (vehicleInfoId) {
          this.listLoadding = true
          let queryParams = []
          let sortParam = null
          queryParams.push(genQueryParam('vehicleInfoId', 'EQ', vehicleInfoId))
          store.dispatch('BusinessNoteServ_GetMyAllCanSee', {
            params: {
              vehicleId: vehicleInfoId
            },
            urlparams: null
          }).then(() => {
            this.listLoadding = false
          }).catch(err => {
            this.listLoadding = false
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    content () {
      if (store.getters.get_BusinessNote_GetMyAllCanSeeResult) {
        return store.getters.get_BusinessNote_GetMyAllCanSeeResult
      } else {
        return []
      }
    },
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
